<template>
  <div>
    <div style="margin-bottom:12px;">
      <button class="btn btn-sm margin5" :class="apiFilter === null ? 'btn-primary text-white' : 'btn-light'" v-on:click="filterApiBlocked(null)">
        Semua User
      </button>
      <button class="btn btn-sm margin5" :class="apiFilter === 1 ? 'btn-danger text-white' : 'btn-light'" v-on:click="filterApiBlocked(1)">
        <i class="fas fa-ban"></i> API Diblokir
      </button>
      <button class="btn btn-sm margin5" :class="apiFilter === 0 ? 'btn-success text-white' : 'btn-light'" v-on:click="filterApiBlocked(0)">
        API Aktif
      </button>
    </div>
    <vue-good-table mode="remote" @on-page-change="onPageChange" @on-sort-change="onSortChange"
      @on-column-filter="onColumnFilter" @on-per-page-change="onPerPageChange" :totalRows="table.total_records"
      :isLoading.sync="table.isLoading" :pagination-options="{
            enabled: true,
            dropdownAllowAll: false,
            perPageDropdown: [10, 25, 50, 100],
          }" :columns="table.columns" :rows="table.rows">
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field == 'action'">
          <button class="btn btn-success text-white margin5" v-on:click="loggedInUser(props.row.id)">
            Login
          </button>
          <br>
          <router-link :to="'/admin/users/edit?id=' + props.row.id">
            <a class="btn btn-primary text-white margin5">Edit</a>
          </router-link>
          <br>
          <a v-on:click="deleteUser(props.row.id)" class="btn btn-danger text-white margin5">
            Hapus
          </a>
          <br>
          <a v-if="props.row.api_blocked == 1" v-on:click="unblockApi(props.row.id)" class="btn btn-success text-white margin5">
            Buka API
          </a>
          <a v-else v-on:click="blockApi(props.row.id)" class="btn btn-warning text-white margin5">
            Blokir API
          </a>
          <br v-if="props.row.topup_blocked == 1">
          <a v-if="props.row.topup_blocked == 1" v-on:click="unblockTopUp(props.row.id)" class="btn btn-success text-white margin5">
            <i class="fas fa-unlock"></i> Buka Blokir Top Up
          </a>
        </span>
        <span v-else-if="props.column.field == 'user_package.package'">
          {{ props.row.user_package ? loadPackage(props.row.user_package.package_id) : "-" }}
        </span>
        <span v-else-if="props.column.field == 'user_package.expired_at'">
          {{ props.row.user_package && props.row.user_package.expired_at ? formatDate(props.row.user_package.expired_at) : "-" }}
        </span>
        <span v-else-if="props.column.field == 'balance'">
          {{ formatRupiah(props.row.balance) }}
          <br>
          Withdrawable : {{ formatRupiah(props.row.withdrawable_balance) }}
        </span>
        <span v-else-if="props.column.field == 'created_by'">
          {{ u[props.row.owner] }}
        </span>
        <span v-else-if="props.column.field == 'level'">
          <span class="badge badge-success" v-if="props.row.level == 'admin'">Admin</span>
          <span class="badge badge-warning text-white" v-else-if="props.row.level == 'agency'">Agency</span>
          <span class="badge badge-secondary text-white" v-else-if="props.row.level == 'user-agency'">User Agency</span>
          <span class="badge badge-info text-white" v-else>User</span>
        </span>
        <span v-else-if="props.column.field == 'api_blocked'">
          <span class="badge badge-danger text-white" v-if="props.row.api_blocked == 1">API Diblokir</span>
          <span class="badge badge-success text-white" v-else>API Aktif</span>
        </span>
        <span v-else-if="props.column.field == 'topup_status'">
          <span class="badge badge-danger text-white" v-if="props.row.topup_blocked == 1">TOP UP DIBLOKIR</span>
          <span class="badge badge-success text-white" v-else>Top Up Aktif</span>
          <br v-if="topupUnpaidCount(props.row) > 0">
          <span class="badge badge-warning text-white margin5" v-if="topupUnpaidCount(props.row) > 0">Belum dibayar: {{ topupUnpaidCount(props.row) }}</span>
        </span>
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>
    </vue-good-table>
  </div>
</template>

<script>
  import moment from 'moment'

  export default {
    props: {
      owner: {
        type: String,
        default: null
      }
    },
    data() {
      return {
        table: {
          total_records: 100,
          isLoading: true,
          columns: [{
              label: "Username",
              field: "username",
              filterOptions: {
                enabled: true,
              },
              sortable: false,
              width: "15%",
            },
            {
              label: "Email",
              field: "email",
              filterOptions: {
                enabled: true,
              },
              sortable: false,
              width: "15%",
            },
            {
              label: "Phone",
              field: "phone",
              filterOptions: {
                enabled: true,
              },
              sortable: false,
              width: "10%",
            },
            {
              label: "Balance",
              field: "balance",
              filterOptions: {
                enabled: false,
              },
              sortable: false,
              width: "10%",
            },
            {
              label: "Paket",
              field: "user_package.package",
              filterOptions: {
                enabled: false,
              },
              sortable: false,
              width: "10%",
            },
            {
              label: "Kedaluwarsa",
              field: "user_package.expired_at",
              filterOptions: {
                enabled: false,
              },
              sortable: false,
              width: "10%",
            },
            {
              label: "Created By",
              field: "created_by",
              filterOptions: {
                enabled: false,
              },
              sortable: false,
              width: "10%",
            },
            {
              label: "Level",
              field: "level",
              filterOptions: {
                enabled: false,
              },
              sortable: false,
              width: "10%",
            },
            {
              label: "API",
              field: "api_blocked",
              sortable: false,
              width: "8%",
            },
            {
              label: "Top Up",
              field: "topup_status",
              sortable: false,
              width: "10%",
            },
            {
              label: "Action",
              field: "action",
              sortable: false,
              width: "20%",
            },
          ],
          rows: [],
          serverParams: {
            columnFilters: {},
            sort: [{
              field: "",
              type: "",
            }, ],
            page: 1,
            limit: 10,
          },
        },
        p: [],
        u: {},
        apiFilter: null,
      };
    },
    mounted() {
      this.fn = () => {
        this.loadItems();
      }
      this.$root.$on("refresh_table", this.fn);
      this.loadItems();
    },
    beforeDestroy() {
      this.$root.$off("refresh_table", this.fn);
    },
    methods: {
      async deleteCoupon(id) {
        try {
          let response = await this.$store.dispatch("admin_coupon_delete", id);
          this.loadItems();
          this.$toast.success(response.data.message);
        } catch (err) {
          this.$toast.error("Server error");
        }
      },
      updateParams(newProps) {
        this.table.serverParams = Object.assign({},
          this.table.serverParams,
          newProps
        );
      },
      onPageChange(params) {
        this.updateParams({
          page: params.currentPage
        });
        this.loadItems();
      },
      onPerPageChange(params) {
        this.updateParams({
          limit: params.currentPerPage
        });
        this.loadItems();
      },
      onSortChange(params) {
        this.updateParams({
          sort: [{
            type: params.sortType,
            field: this.table.columns[params.columnIndex].field,
          }, ],
        });
        this.loadItems();
      },
      onColumnFilter(params) {
        this.updateParams(params);
        // Debounce 500ms — supaya tidak fire request tiap karakter saat user ketik filter
        if (this._filterDebounceTimer) clearTimeout(this._filterDebounceTimer);
        this._filterDebounceTimer = setTimeout(() => {
          this.loadItems();
        }, 500);
      },
      async loadItems() {
        this.table.isLoading = true;
        try {
          // Cache packages — fetch hanya kalau belum di-load
          if (!this.p || this.p.length === 0) {
            try {
              const p = await this.$store.dispatch('package_list');
              this.p = (p && p.data && p.data.data && p.data.data.packages) || [];
            } catch (e) {
              console.warn('[UserTable] package_list failed:', e);
              this.p = [];
            }
          }

          if (this.owner) {
            this.table.serverParams.owner = this.owner;
          }

          let response;
          try {
            response = await this.getFromServer(this.table.serverParams);
          } catch (e) {
            console.error('[UserTable] getFromServer failed:', e);
            this.$toast.error('Gagal load user list');
            return;
          }

          const data = (response && response.data && response.data.data) || {};
          this.table.total_records = data.total_records || 0;
          this.table.rows = data.users || [];

          // Owner-loader: parallel + non-blocking
          const uniqueOwners = [...new Set(
            this.table.rows
              .map(r => r && r.owner)
              .filter(o => o && o !== 0 && !this.u[o])
          )];
          if (uniqueOwners.length > 0) {
            Promise.all(uniqueOwners.map(o => this.loadOwner(o))).catch(() => { /* silent */ });
          }
        } catch (err) {
          console.error('[UserTable] loadItems error:', err);
        } finally {
          // GUARANTEED clear isLoading — apapun yang terjadi
          this.table.isLoading = false;
        }
      },
      async getFromServer(param) {
        return await this.$store.dispatch("admin_user_list", param);
      },
      loadPackage(package_id) {
        for (let i = 0; i < this.p.length; i++) {
          const element = this.p[i];
          if (element.id == package_id) {
            return element.name
          }
        }
      },
      async loadOwner(owner) {
        if (!owner || owner == "0") {
          this.u[owner] = "-"
        } else {
          let u = await this.$store.dispatch('admin_user_one', {
            id: owner
          })
          this.$set(this.u, owner, u.data.data.user.username ?? "-")
        }
      },
      async loggedInUser(id) {
        try {
          await this.$store.dispatch("auth_login_admin", {id: id});
          await this.$root.$emit("login", true);
          // await this.$toast.success("Login success");
          await this.$router.push("/dashboard");
          window.location.reload()
        } catch (err) {
          this.$toast.error(err.response.data.message);
        }
      },
      formatDate(val) {
        return moment.unix(val / 1000).format('YYYY-MM-DD')
      },
      formatRupiah(numb) {
        const format = numb.toString().split('').reverse().join('');
        const convert = format.match(/\d{1,3}/g);
        const rupiah = 'Rp ' + convert.join('.').split('').reverse().join('')
        return rupiah
      },
      async deleteUser(id){
        if (!confirm("Yakin ingin hapus user ?")) return

        try {
          let res = await this.$store.dispatch("admin_user_delete", {
            id: id
          })
          this.$toast.success(res.data.message)
          this.loadItems();
        } catch (err) {
          this.$toast.error(err.response.data.message)
        }
      },
      async blockApi(id){
        const reason = prompt("Alasan blokir API (opsional):", "")
        if (reason === null) return
        if (!confirm("Yakin blokir akses API user ini?")) return
        try {
          let res = await this.$store.dispatch("admin_user_api_block", {
            id: id,
            reason: reason
          })
          this.$toast.success(res.data.message)
          this.loadItems();
        } catch (err) {
          this.$toast.error(err.response.data.message)
        }
      },
      async unblockApi(id){
        if (!confirm("Buka kembali akses API user ini?")) return
        try {
          let res = await this.$store.dispatch("admin_user_api_unblock", {
            id: id
          })
          this.$toast.success(res.data.message)
          this.loadItems();
        } catch (err) {
          this.$toast.error(err.response.data.message)
        }
      },
      topupUnpaidCount(row) {
        return parseInt(row.topup_unpaid_count) || 0
      },
      async unblockTopUp(id) {
        if (!confirm("Buka blokir top up untuk user ini? User masih bisa punya top up pending.")) return
        try {
          let res = await this.$store.dispatch("admin_user_unblock_topup", { id: id })
          this.$toast.success(res.data.message)
          this.loadItems()
        } catch (err) {
          this.$toast.error((err.response && err.response.data && err.response.data.message) || "Gagal buka blokir top up")
        }
      },
      filterApiBlocked(val){
        this.apiFilter = val;
        if (val === null) {
          this.$delete(this.table.serverParams, 'api_blocked');
        } else {
          this.$set(this.table.serverParams, 'api_blocked', val);
        }
        this.table.serverParams.page = 1;
        this.loadItems();
      }
    },
  };
</script>

<style scoped>
  .margin5 {
    margin: 5px;
  }
</style>